module.exports = __webpack_public_path__ + "img/icon_map_4.ade7a770.png";